G._addNewPhrases = function(txt) {
  /* This doesnt seem to be used anymore ?

  const langs = ["en", "de", "es", "fr", "it", "pt", "ru", "tr", "nl", "pl", "vi", "pr-br", "hi"];
  const splitedTxts = txt.split("\n").map(line => line.split("\t"))

  langs.forEach((lang, i)=>{
    splitedTxts.forEach(line=>{
      if (line[i]) {
        if (OMT.language.languageData[lang]) {
          OMT.language.languageData[lang][line[0]] = line[i] || line[0];
        }
      }
    });
  });
  copy(JSON.stringify(OMT.language.languageData, null, '\t'));
  alert("copied");
  */
};